import { render } from "./CafeView.vue?vue&type=template&id=b3cafde0&scoped=true"
import script from "./CafeView.vue?vue&type=script&lang=js"
export * from "./CafeView.vue?vue&type=script&lang=js"

import "./CafeView.vue?vue&type=style&index=0&id=b3cafde0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3cafde0"]])

export default __exports__